import React from 'react';

import { BrowserRouter as Provider } from 'react-router-dom';

export const ReactRouterProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => <Provider>{children}</Provider>;
